import { getEffectivePlan, isOverrideExpired } from "./planMeta";

// Rótulos dos campos que vêm crus do backend (mesmas chaves de src/config/businessAreas.js
// e do enum acquisitionSource do model User).
export const BUSINESS_AREA_LABELS = {
  lash: "Lash Designer",
  sobrancelha: "Sobrancelhas",
  unhas: "Nail Designer",
  cabelo: "Cabeleireira",
  maquiagem: "Maquiagem",
  bronzeamento: "Bronzeamento",
  estetica: "Estética",
  depilacao: "Depilação",
  micropigmentacao: "Micropigmentação",
  massagem: "Massagem",
  podologia: "Podologia",
  barbearia: "Barbearia",
  outro: "Outro",
};

export const ACQUISITION_LABELS = {
  instagram: "Instagram",
  facebook: "Facebook",
  google: "Google",
  indicacao: "Indicação",
  outro: "Outro",
};

export const ROLE_LABELS = { admin: "Administrador", user: "Usuário", patner: "Parceiro", trial: "Trial" };

const DAY = 86400000;

export const daysSince = (date) => (date ? Math.floor((Date.now() - new Date(date).getTime()) / DAY) : null);

export const countOf = (person, key) => (Array.isArray(person?.[key]) ? person[key].length : 0);

// Assinatura paga de verdade (não conta plano manual)
export const isPayingSubscriber = (person) => person?.subscription === "active" && Boolean(person?.subscriptionPlan);

export const hasActiveOverride = (person) => Boolean(person?.planOverride) && !isOverrideExpired(person);

// Conta criada há mais de 3 dias e que ainda não marcou nenhum agendamento — boa candidata
// pra um contato de ativação.
export const isInactiveAccount = (person) => countOf(person, "appointments") === 0 && (daysSince(person?.createdAt) ?? 0) >= 3;

// Data da próxima cobrança/renovação: Kiwify grava nextBillingDate; Apple vem do RevenueCat.
export const getRenewalDate = (person) => {
  if (person?.subscription !== "active") return null;
  const date = person?.paymentMethod === "kiwify" ? person?.nextBillingDate : person?.revenueCat?.expirationDate || person?.nextBillingDate;
  return date ? new Date(date) : null;
};

export const getPaymentLabel = (person) => {
  const method = String(person?.paymentMethod || person?.provider || "").toLowerCase();
  if (!method) return null;
  if (method.includes("kiwify")) return "Kiwify";
  if (method.includes("apple") || method.includes("app_store") || method.includes("ios")) return "Apple";
  if (method.includes("google") || method.includes("play")) return "Google Play";
  if (method.includes("revenuecat")) return "App Store";
  return person.paymentMethod || person.provider;
};

export const isWithinDays = (date, from, to) => {
  if (!date) return false;
  const t = new Date(date).getTime();
  return t >= Date.now() - from * DAY && t < Date.now() - to * DAY;
};

export const formatDate = (date, opts = { day: "2-digit", month: "short", year: "numeric" }) =>
  date ? new Date(date).toLocaleDateString("pt-BR", opts).replace(/\./g, "").replace(/ de /g, " ") : "—";

export const formatRelative = (date) => {
  const d = daysSince(date);
  if (d === null) return "";
  if (d <= 0) return "hoje";
  if (d === 1) return "ontem";
  if (d < 30) return `há ${d} dias`;
  const months = Math.floor(d / 30);
  if (months < 12) return `há ${months} ${months === 1 ? "mês" : "meses"}`;
  const years = Math.floor(d / 365);
  return `há ${years} ${years === 1 ? "ano" : "anos"}`;
};

export const formatCurrency = (amount) =>
  Number(amount || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const formatNumber = (n) => Number(n || 0).toLocaleString("pt-BR");

export const formatPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  const m = digits.match(/^55(\d{2})(\d{4,5})(\d{4})$/);
  if (m) return `+55 (${m[1]}) ${m[2]}-${m[3]}`;
  return phone ? String(phone) : "";
};

export { getEffectivePlan };
